import React, { useState, useEffect } from 'react';
import './BacklinkToolModal.css'; // استایل‌ها را در ادامه اضافه می‌کنیم

const BacklinkToolModal = ({ isOpen, onClose, onGenerateMap }) => {
  const [pages, setPages] = useState([]);
  const [selectedPages, setSelectedPages] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      setError('');
      const apiUrl = 'https://sseo.afaq.lc/seo_architect_api/get_link_data.php';
      const token = localStorage.getItem('authToken');

      fetch(apiUrl, { headers: { 'Authorization': `Bearer ${token}` } })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setPages(data.data);
          } else {
            setError(data.message || 'خطا در دریافت لیست صفحات.');
          }
        })
        .catch(() => setError('خطای شبکه.'))
        .finally(() => setLoading(false));
    }
  }, [isOpen]);

  const handleSelectPage = (pageId) => {
    const newSelection = new Set(selectedPages);
    if (newSelection.has(pageId)) {
      newSelection.delete(pageId);
    } else {
      newSelection.add(pageId);
    }
    setSelectedPages(newSelection);
  };
  
  const handleSelectAll = () => {
    if (selectedPages.size === pages.length) {
        setSelectedPages(new Set());
    } else {
        setSelectedPages(new Set(pages.map(p => p.id)));
    }
  };

  const handleGenerateClick = () => {
    if (selectedPages.size > 0) {
      onGenerateMap(Array.from(selectedPages));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="tool-modal-overlay" onClick={onClose}>
      <div className="tool-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="tool-modal-header">
          <h3>ساخت نقشه بک‌لینک‌ها</h3>
          <button onClick={onClose} className="close-btn">&times;</button>
        </div>
        <div className="tool-modal-body">
          <p>صفحاتی که می‌خواهید در نقشه نمایش داده شوند را انتخاب کنید.</p>
          {loading && <p>در حال بارگذاری لیست صفحات...</p>}
          {error && <p className="error-message">{error}</p>}
          {!loading && !error && (
            <>
              <div className="page-list-actions">
                <button onClick={handleSelectAll}>
                    {selectedPages.size === pages.length ? 'لغو انتخاب همه' : 'انتخاب همه'}
                </button>
              </div>
              <ul className="pages-checklist">
                {pages.map(page => (
                  <li key={page.id} onClick={() => handleSelectPage(page.id)}>
                    <input
                      type="checkbox"
                      checked={selectedPages.has(page.id)}
                      readOnly
                    />
                    <label>{page.label}</label>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
        <div className="tool-modal-footer">
          <button onClick={handleGenerateClick} disabled={selectedPages.size === 0}>
            مشاهده نقشه بک‌لینک‌ها
          </button>
        </div>
      </div>
    </div>
  );
};

export default BacklinkToolModal;